<template>
  <div
    class="flex flex-col gap-1"
    ref="wrapper"
    :class="{
      'items-end': $props.config.position === 'right',
      'items-start': $props.config.position === 'left'
    }"
  >
    <div
      class="bubble items-center justify-center text-center size-16 grid grid-flow-row auto-rows-auto auto-cols-auto rounded-full cursor-pointer shadow-lg"
      :style="{ backgroundColor: $props.config.beaconBGColor }"
      @click="startBell"
      data-test-id="bell_icon"
    >
      <template v-if="isBackgroundWhite">
        <img class="size-8 mb-1" :src="LogoGold" />
      </template>
      <template v-else>
        <img class="size-8 mb-1" :src="LogoWhite" />
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { BubbleConfig } from '../../types/BubbleConfig'
import { type ComputedRef, type Ref, computed, ref, onMounted, onErrorCaptured } from 'vue'
import { captureException } from '@/bubble'
import LogoGold from '../assets/logo-gold.svg'
import LogoWhite from '../assets/logo-white.svg'
import { CustomElementHelper } from '@/utility/CustomElements'
import { CustomElementTags } from '@/utility/Constants'
const props = defineProps<{
  config: BubbleConfig
}>()
const emit = defineEmits<{
  (e: 'start'): void
}>()
const isButtonDisabled = ref(false)
let wrapper: Ref<HTMLDivElement | undefined> = ref(undefined)
let bellPopupCe: HTMLElement | undefined = undefined
// @ts-expect-error NodeJS isn't defined.
let bellPopupTimeout: NodeJS.Timeout | undefined = undefined
const isBackgroundWhite: ComputedRef<boolean> = computed(() => {
  return (
    props.config.beaconBGColor.toUpperCase() === '#FFFFFF' ||
    props.config.beaconBGColor.toUpperCase() === '#FFF'
  )
})
const startBell = () => {
  if (!isButtonDisabled.value) {
    isButtonDisabled.value = true
    setTimeout(() => {
      isButtonDisabled.value = false
    }, 1000)
    if (bellPopupTimeout) {
      clearTimeout(bellPopupTimeout)
    }
    emit('start')
  }
}
onMounted(() => {
  bellPopupTimeout = setTimeout(() => {
    const bellPopupCE = CustomElementHelper.createCustomElement(CustomElementTags.POPUP, { config: props.config });
    bellPopupCe = bellPopupCE;
    bellPopupCE.addEventListener('closePopup', () => {
      bellPopupCE.remove()
    })
    bellPopupCE.addEventListener('start', () => {
      emit('start')
    })
    wrapper.value?.prepend(bellPopupCE)
  }, 1)
})
onErrorCaptured((err, vm, info) => {
  captureException(err);
})
</script>
<style scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>
